// src/app/core/shared/condition.store.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConditionStore {
    private subject = new BehaviorSubject<string>('HTN'); // default
    setCondition(id: string) { this.subject.next(id); }
    getCondition$() { return this.subject.asObservable(); }
    getCondition() { return this.subject.value; }
}